 <!-- Fenêtres de chat -->
<!-- -->


  <div class="chat-window">
    <div class="chat-header">{{selectedUser.publicName}} <button (click)="closeChatWindow()">X</button> <!-- Bouton pour fermer la fenêtre --></div>
    <div class="chat-messages">
      <div *ngFor="let message of messages">
        <span [ngClass]="{'my-message': message.senderId === currentUserId}">
          {{message.text}}
        </span>
      </div>
    </div>
    <div class="chat-input">
      <input [(ngModel)]="newMessage" placeholder="Type your message">
      <button (click)="sendMessage()">Envoyer</button>
    </div>
  </div>
  

  
